export enum Status {
    idle = 'IDLE',
    loading = 'LOADING',
    succeeded = 'SUCCESS',
    failed = 'FAILED',
    loging = 'LOGING',
    loggedin = 'LOGGEDIN',
    loggedout = 'LOGGEDOUT',
    registering = 'REGISTERING',
}

export interface Category {
    searchQuery: string;
    action: string;
    id: string;
    name: string;
}
  